import React, { useState } from "react"
import BackButton from "../../../components/common/BackButton/BackButton"
import banner from "../../../assets/images/UserPortal/banner.png"
import styles from "./CustomerServices.module.scss"
import YellowHeaderWrapper from "../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper"
import { Col, Row } from "reactstrap"
import { CiViewList } from "react-icons/ci"
import { TbTruckDelivery } from "react-icons/tb"
import classNames from "classnames"
import { MdAssignmentReturned } from "react-icons/md"
import { BsChevronRight, BsChevronDown } from "react-icons/bs"
import { GoCreditCard } from "react-icons/go"
import { GrAnnounce } from "react-icons/gr"
import { RiUserSettingsLine } from "react-icons/ri"
import { PiShieldWarning } from "react-icons/pi"
import { LuLightbulb } from "react-icons/lu"
import { FaRegHeart } from "react-icons/fa"
import { useNavigate } from "react-router-dom"

const CustomerServices = () => {
  const [active, setActive] = useState(0)
  const [label, setLabel] = useState("Order Issues")
  const navigate = useNavigate()

  const FAQCategories = [
    { icon: CiViewList, label: "Order Issues" },
    { icon: TbTruckDelivery, label: "Delivery" },
    { icon: MdAssignmentReturned, label: "Returns & Refunds" },
    { icon: GoCreditCard, label: "Payment" },
    { icon: GrAnnounce, label: "Promo Issues" },
    { icon: RiUserSettingsLine, label: "My account/ technical" },
    { icon: PiShieldWarning, label: "Report suspicious activity" },
    { icon: LuLightbulb, label: "Suggestion/Dispute" },
    { icon: FaRegHeart, label: "Wanna say Thanks?" },
  ]

  const questions = {
    "Order Issues": [
      "How i can place my order?",
      "How are shipping costs calculated?",
      "Can I change the shipping address after I have placed my order?",
      "Do you ship internationally?",
      "What happens if my order is lost in transit?",
      "Can I ship different items in my order to different addresses?",
      "How do I qualify for free shipping?",
      "What should I do if I receive a damaged item?",
      "Do you provide tracking information?",
      "Can I place an order over the phone?",
      "How are shipping costs calculated?",
      "Can I change the shipping address after I have placed my order?",
    ],
  }

  const topQuestions = [
    "What should I do if I receive a damaged item?",
    "Do you provide tracking information?",
    "Can I place an order over the phone?",
    "How are shipping costs calculated?",
  ]

  const handleClick = (index, label) => {
    setActive(index)
    setLabel(label)
  }

  return (
    <div>
      <BackButton />
      <div className={styles["banner-container"]}>
        <img src={banner} alt="" className="w-100" />
        <div className={styles["content"]}>
          <div className={styles["banner-heading"]}>Frequently Asked Question (FAQ’s)</div>
          <div className={styles["para"]}>What issues are you facing?</div>
          <div className={styles["para"]}>We are here for solving our customers problems.</div>
        </div>
      </div>

      <div className="m-3">
        <div className="fs-md-4">
          We are here to help our customers. Please checkout from the following to sort out your problem or you can contact to our help center for further help.
        </div>

        <YellowHeaderWrapper title={"FAQ Categories"} bordered={false}>
          <Row noGutters>
            <Col xs="12" md="2">
              <div className={`${styles['scroll-container']} d-flex d-md-block gap-1 overflow-x-auto`}>
                {FAQCategories.map(({ icon: Icon, label }, index) => (
                  <div
                    key={index}
                    className={classNames("d-flex gap-2 align-items-center mt-2 mt-md-0 px-2 py-1 p-md-3 cursor-pointer", styles["category-tab"], {
                      [styles["active-category"]]: active === index,
                    })}
                    onClick={() => handleClick(index, label)}
                  >
                    <Icon size={24} />
                    <div className="text-md-wrap text-nowrap">{label}</div>
                  </div>
                ))}
              </div>
            </Col>
            <Col>
              {questions[label]?.length > 0 ? (
                questions[label]?.map((item, index) => (
                  <div key={index} className={classNames("p-3", styles.listItems)} onClick={() => navigate("/FAQs")}>
                    <div>{item}</div>{" "}
                    <div>
                      <BsChevronRight />
                    </div>
                  </div>
                ))
              ) : (
                <div className="p-3">No Questions</div>
              )}
            </Col>
          </Row>
        </YellowHeaderWrapper>

        <YellowHeaderWrapper title={"Top Questions"} bordered={false}>
          <div className={styles["top-questions"]}>
            {topQuestions.map((item, index) => (
              <div key={index} className={classNames("p-3", styles["top-question"])}>
                <div>{item}</div>
                <div>
                  <BsChevronDown />
                </div>
              </div>
            ))}
          </div>
        </YellowHeaderWrapper>

        <div className="d-flex justify-content-center">
          <div className="py-3 px-5 shadow text-center my-3">
            <div className="fs-5 mb-2">Can’t find a question you are looking for?</div>
            <button className={styles["customer-service-button"]}>Customer Service</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerServices
